export default {
  licences: {

  },
  refreshLicences: false,
  loading: false,
  stateChanged: false
}
